var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "wrapper box" }, [
        _c("div", [
          _c("h1", [_vm._v("用户服务协议")]),
          _vm._v(" "),
          _c("h2", [_vm._v("一、总则")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "1.1\n        为了保护网络信息安全，保障公民、法人和其他组织的合法权益，维护国家安全和社会公共利益，根据国家法律法规及其他相关规定，国家职业教育智慧教育平台制定并按照本协议提供网络服务。用户应当充分阅读并同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户阅读并接受本协议后，方可使用国家职业教育智慧教育平台提供的服务。用户使用国家职业教育智慧教育平台的服务即视为用户已阅读并同意受本协议的约束。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "1.2 用户注册成功后，用户需自行保管其账号和密码；如您发现或怀疑您的账户或密码已经泄露，必须尽快通知我们。\n        除非我们已接获并确认收到您向我们发出关于您的账户/密码被泄露的通知，我们会将所有在我们的服务内对您账户的使用视为由您做出。因您保管不善可能导致遭受盗号或密码失窃，责任由您自行承担。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "1.3\n        用户可以使用国家职业教育智慧教育平台提供的各个单项服务，当用户使用国家职业教育智慧教育平台各单项服务时，用户的使用行为视为其对该单项服务的服务协议以及国家职业教育智慧教育平台在该单项服务中发出的各类公告、声明或其它类似内容的同意。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "1.4 我们可能随时修改本服务协议及各个单项服务协议和公告，\n        故请时常访问国家职业教育智慧教育平台网站或国家职业教育智慧教育平台应用中查阅（您可以通过“我的-设置-关于国家职业教育智慧教育平台”路径查阅本协议及《用户隐私保护政策》的最新版本）。我们可能不时增加、变更或完全终止我们的服务项目。\n        若我们认为对本服务协议或我们服务进行了合理而重大的修改，我们将在修改生效前通过我们的网站、与您直接联系或者其他方式通知您。就服务协议或我们的服务的任何修改，无论我们是否发出通知，如果您继续使用我们的服务，即表示同意被经修订的本条款约束。国家职业教育智慧教育平台的通知、公告、声明或其它类似内容是本协议的组成部分。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("二、注册信息和隐私保护")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "2.1 国家职业教育智慧教育平台账号（即用户\n        ID）的所有权归国家职业教育智慧教育平台，用户完成注册申请手续后，获得国家职业教育智慧教育平台账号的使用权。我们可以将遵守某些条件或要求作为用户访问和使用国家职业教育智慧教育平台应用特定功能的条件，例如完成学校、班级的选择等。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "2.2\n        用户不应将其账号、密码转让、出售或出借予他人使用，如果国家职业教育智慧教育平台发现使用者并非账号注册者本人，有权停止继续服务。用户应妥善保管账号及密码，如用户发现其账号遭他人非法使用，应立即通知国家职业教育智慧教育平台。因黑客行为或用户违反本协议规定导致账号、密码遭他人非法使用的，由用户本人承担因此导致的损失和一切法律责任。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "2.3 您必须至少年满 18 周岁，有能力订立具有法律约束力的合同，以访问和使用国家职业教育智慧教育平台应用。您访问或使用国家职业教育智慧教育平台应用，即表示您陈述和保证您已年满 18\n        周岁，且具有订立合同的法律行为能力和授权。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("2.4 您需负责：")]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v("(1) 保管用以进入您的账户和我们的服务的任何密码；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(2)\n        承担通过您的账户对我们的服务所做出的一切使用行为。如您发现或怀疑您的账户或密码已经泄露，必须尽快通知我们。除非我们已接获并确认收到您向我们发出关于您的账户/密码被泄露的通知，我们会将所有在我们的服务内对您账户的使用视为由您做出。因您保管不善可能导致遭受盗号或密码失窃，责任由您自行承担。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "2.5 尊重用户个人隐私是国家职业教育智慧教育平台的一项基本政策。我们不会在未经您明示授权时透露您的注册资料，除非："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v("(1) 相关法律法规或国家机关要求；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(2) 国家职业教育智慧教育平台发生相关合并、分立、收购或资产转移；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v("(3) 为提供相关服务所必须的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(4)\n        国家职业教育智慧教育平台可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与国家职业教育智慧教育平台同等的保护用户隐私的责任，则国家职业教育智慧教育平台有权将用户的注册资料等提供给该第三方。对于您所提交的注册信息中涉及个人信息的内容，我们将严格按照《用户隐私保护政策》的规定进行收集、处理和使用。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "2.6 在不透露用户的个人敏感信息、且对用户信息进行去标识化处理的前提下，国家职业教育智慧教育平台有权对用户数据进行分析并进行商业化使用，用以改进为您提供的服务。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "2.7 国家职业教育智慧教育平台如发现用户账号中含有不雅文字或不恰当名称的，将根据情节采取警告或注销账户等措施："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(1) 请勿以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v("(2) 请勿以国家机构或其他机构的名称注册；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(3) 请勿注册不文明、不健康名字，或包含歧视、侮辱、猥亵类词语的账号；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(4) 请勿注册易产生歧义、引起他人误解或其它不符合法律规定的账号。"
            ),
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("三、使用规则")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "3.1 用户在使用国家职业教育智慧教育平台提供的服务时，必须遵守中华人民共和国相关法律法规的规定，用户应承诺不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为∶"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(1) 上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v("1) 反对宪法所确定的基本原则的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v(
              "2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v("3) 损害国家荣誉和利益的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v("4) 煽动民族仇恨、民族歧视、破坏民族团结的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v("5) 破坏国家宗教政策，宣扬邪教和封建迷信的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v("6) 散布谣言，扰乱社会秩序，破坏社会稳定的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v("7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v("8) 侮辱或者诽谤他人，侵害他人合法权利的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v(
              "9) 含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v(
              "10) 含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v("(2) 不得为任何非法目的而使用网络服务系统；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(3) 不利用国家职业教育智慧教育平台提供的服务从事以下活动："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v(
              "1) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v(
              "2) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v(
              "3) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v("4) 故意制作、传播计算机病毒等破坏性程序的；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tertiary-indent" }, [
            _vm._v("5) 其他危害计算机信息网络安全的行为。"),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "3.2 根据《中华人民共和国教师法》及《中学教师职业道德规范》的相关规定：教师负有关心、爱护全体学生，尊重学生人格，促进学生在品德、智力、体质等方面全面发展的义务，因此，您应保证："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(1) 对于通过国家职业教育智慧教育平台获悉的任何学生个人隐私、信息或资料（包括但不限于学生的学业成绩、课业情况等信息）负有保密义务；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v("(2) 不得进行辱骂、讽刺、挖苦、歧视学生的行为。"),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "3.3\n        用户违反本协议或相关的服务协议的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，国家职业教育智慧教育平台不承担任何责任，同时用户同意赔偿第三方、国家职业教育智慧教育平台及关联公司。对此，国家职业教育智慧教育平台有权视用户的行为性质，采取包括但不限于删除用户发布信息内容、暂停使用许可、终止服务、限制使用、回收国家职业教育智慧教育平台账号、追究法律责任等措施。对恶意注册国家职业教育智慧教育平台账号或利用国家职业教育智慧教育平台账号进行违法活动、捣乱、骚扰、欺骗以及其他违反本协议的行为，国家职业教育智慧教育平台有权回收其账号。同时，国家职业教育智慧教育平台会视司法部门的要求，协助调查。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "3.4 当您使用我们的服务或通过我们的服务而提交、上传、发布、产生、传送或显示的任何数据、资料、信息、语音、图像、媒体、作品、链接、回复或其他内容（“您的内容”）时，您同意并知悉："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(1) 无偿授权我们和我们的关联公司使用您的内容，包括以您的内容制作汇编作品、衍生作品、公开展示、表演您的内容，作为提供、宣传、推广、提升我们的服务之用；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(2) 我们可使用您用以提交您的内容的名称（包括您的账户名称、真实名称或其他名称）和您上传到国家职业教育智慧教育平台上的肖像或含有您肖像的摄影作品以及个人信息；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(3) 在使用您的内容时，我们和我们的关联公司可以在全球各地于任何媒体，并通过任何发布方法，复制、改编、汇编、修改、翻译、发行、刊登您的内容；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(4) 我们可以与协助我们提供、宣传、研发和提升我们的服务的第三方分享您的内容。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("3.5 您同意我们和我们的关联公司：")]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(1) 可以在您停止使用我们的服务后，保留并继续使用您的内容；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(2) 保留或披露您的内容，以便遵守相关法律规例或法院、政府机关的要求；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(3)\n        为了完成合并、分立、收购或资产转让、保护我们的权利、财产或安全或我们关联公司、我们的服务的其他用户的权利、财产或安全而需要或为提供您要求的服务而披露您的内容（包括与您在国家职业教育智慧教育平台应用开立的账户有关的任何资料）。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("3.6 您承诺并保证：")]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(1) 您对您的内容享有完整权利，并有权授予我们本条款项下的各项权利；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(2) 您的内容并未侵犯任何第三人的权利，我们根据您的授权使用您的内容亦不会对第三方构成侵权或触犯任何法律法规。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "3.7 如果我们收到权利人通知，主张您发送或传播的内容侵犯其相关权利的，您同意我们有权进行独立判断并采取删除、屏蔽或断开链接等措施。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "3.8 我们收集、保存、传输、使用您的内容将不违反相关法律规定，并适用我们的《用户隐私保护政策》，受其约束。"
            ),
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("四、服务内容")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "4.1 国家职业教育智慧教育平台网络服务的具体内容由国家职业教育智慧教育平台根据实际情况提供；国家职业教育智慧教育平台将不时推出新产品、新功能、新服务，以上服务亦受到本服务协议之规范。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "4.2 用户应当理解，使用国家职业教育智慧教育平台的服务需自行准备与相关服务有关的终端设备（如手机、平板等装置），并承担所需的费用（如电话费、上网费等费用），同时使用本服务时会耗用用户的终端设备和带宽等资源。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "4.3\n        您理解并同意，我们的所有服务和软件均是按原状而提供。我们将尽最大努力向您提供服务，确保服务的连贯性和安全性；但国家职业教育智慧教育平台没有对我们的服务、软件或任何通过国家职业教育智慧教育平台的服务提交、提供或显示的内容做出任何声明、保证或给予任何承诺，包括：\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(1) 我们的服务或软件将不受干扰、是安全的、没有错漏或没有病毒；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v("(2) 我们的服务或软件将会与您的设备兼容；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(3) 我们的服务或软件将具适销质量、适合特定用途或没有侵犯任何人的知识产权的任何声明、保证或承诺。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "4.4\n        您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使服务中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，我们将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失我们在法律允许的范围内免责。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "4.5 在法律允许的范围内，我们对以下情形导致的服务中断或受阻不承担责任："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v("(1) 受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v("(2) 用户或我们的电脑软件、系统、硬件和通信线路出现故障；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v("(3) 用户操作不当；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(4) 用户通过非国家职业教育智慧教育平台授权的方式使用本服务；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(5) 其他国家职业教育智慧教育平台无法控制或合理预见的情形。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "4.6 您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，我们不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "4.7 您知悉并同意，我们的服务可能包含广告。您同意我们可以在国家职业教育智慧教育平台应用内加入、展示及在其他方面传达广告或商业内容。您亦同意，我们会使用针对目标对象的广告，尝试提供更适合您并对您有用的广告。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "4.8 我们可以暂停或终止您进入您的国家职业教育智慧教育平台账户或我们的部分或所有服务："
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v("(1) 如我们合理相信您已违反本协议；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(2) 如您使用国家职业教育智慧教育平台服务对我们或我们的其他用户造成风险、可能导致我们面临第三方提出索赔的威胁，或可能影响我们的声誉；"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v("(3) 如您有很长时间没有使用我们的服务；"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "secondary-indent" }, [
            _vm._v(
              "(4) 任何其他原因。在合理可行情况下，我们会向您发出暂停或终止服务通知。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "4.9\n        在终止本条款后，我们会根据本条款及我们的《用户隐私保护政策》保留并使用您的内容。如我们暂停或终止某服务，或您或我们终止您进入我们的服务，我们不保证我们可以将您的任何内容交还给您，而且我们可能会在服务终止后的任何时间未经通知而永久删除您的内容。请确保您定期为您的内容存档。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("五、知识产权和其他合法权益")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "5.1 国家职业教育智慧教育平台向用户提供的所有产品和服务，包括但不限于商标、域名、软件程序、图片、声音、录像、图表、标志、标识、版面设计、目录与名称等，均归国家职业教育智慧教育平台所有，受国家相关法律保护。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "5.2\n        未经国家职业教育智慧教育平台书面许可，任何单位及个人不得以任何方式或理由将上述产品、服务、信息、文字材料的任何部分用于商业、营利或广告目的；不得擅自进行复制、分发、修改、编辑、传播、表演、展示、程序反向工程、镜像、销售或与其它产品捆绑使用、销售。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "5.3 用户使用国家职业教育智慧教育平台提供的内容与服务时，应遵守知识产权及其他相关法律的规定。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "5.4\n        国家职业教育智慧教育平台内的文章、图片、音频视频文件等资料的版权著作权归相关权利人所有。如您对国家职业教育智慧教育平台上的内容有任何疑问或异议，请通过电话（58556550）联系我们，我们将有专门人员核实、处理。"
            ),
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("六、免责声明")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "6.1\n        您同意我们可以在提供服务过程中向您发送推广或宣传信息（包括商业与非商业信息）。我们将为您提供选择关闭该等信息的功能。我们将依照法律规定对该等信息提供方履行相关义务，但您应当审慎判断信息的真实性和可靠性并为自己的判断行为负责，除法律明确规定外，您应对依该信息进行的交易负责，您因依该信息进行的交易或前述信息提供商提供的内容而遭受的损失或损害，我们不承担责任。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "6.2\n        用户理解并同意，其使用国家职业教育智慧教育平台提供的服务所遭受的风险及其后果将由其自己承担。如因用户违反有关法律、法规或本协议项下的任何条款而给国家职业教育智慧教育平台或任何其他第三人造成损失，用户将承担由此造成的损害赔偿责任。\n      "
            ),
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("七、其他")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "7.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "7.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向具有管辖权的法院提起诉讼。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "7.3 国家职业教育智慧教育平台未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "7.4 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。"
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }